import { Component } from '@angular/core';
import { Icon } from '../icon/icon.component';

@Component({
  selector: 'app-hint',
  template: `
    <div class="flex  items-start gap-2">
      <app-icon name="solar:info-circle-bold-duotone" size="sm" class="text-gray-500" />
      <p class="text-sm text-gray-500 whitespace-pre-line">
        <ng-content />
      </p>
    </div>
  `,
  imports: [Icon],
})
export class Hint {}
